import { UserRoles } from '../types';

export const ROUTES = {
  ROOT: '',
  RECOMMENDATION: 'recommendation',
  PROJECT: 'project',
  DASHBOARD: 'dashboard',
  AUDIT_TRAIL: 'audit-trail',
  USERS: 'users',
  HELP_SUPPORT: 'help-support',
  PROJECT_DESIGN_DOCUMENT: 'Project-Design-Document',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

const COMMON_PERMISSIONS: readonly RoutePath[] = [
  ROUTES.DASHBOARD,
  ROUTES.ROOT,
  ROUTES.HELP_SUPPORT,
];

export const ROUTE_PERMISSIONS: { [key in UserRoles]: readonly RoutePath[] } = {
  [UserRoles.ADMIN]: [...COMMON_PERMISSIONS, ROUTES.PROJECT_DESIGN_DOCUMENT, ROUTES.AUDIT_TRAIL],
  [UserRoles.ADMIN_APPROVER]: [
    ...COMMON_PERMISSIONS,
    ROUTES.PROJECT_DESIGN_DOCUMENT,
    ROUTES.AUDIT_TRAIL,
    ROUTES.USERS,
    ROUTES.PROJECT,
    ROUTES.RECOMMENDATION,
  ],
  [UserRoles.GENERAL]: [...COMMON_PERMISSIONS, ROUTES.PROJECT, ROUTES.RECOMMENDATION],
} as const;
